;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockAnchorProductList from './BlockAnchorProductList';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockAnchorProductList(preview: $preview, id: $id) {
            headline {
                json
            }
            copy
            anchorName
            anchorId
            image {
                ...Asset
            }
            imageLarge {
                ...Asset
            }
            richText {
                json
            }
            anchorId
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockAnchorProductList },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockAnchorProductList;
}

const BlockAnchorProductServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockAnchorProductList {...block} />;
};

export default BlockAnchorProductServer;
